import { render, staticRenderFns } from "./VoiceCommandDisplay.vue?vue&type=template&id=37d48521&scoped=true&"
import script from "./VoiceCommandDisplay.vue?vue&type=script&lang=js&"
export * from "./VoiceCommandDisplay.vue?vue&type=script&lang=js&"
import style0 from "./VoiceCommandDisplay.vue?vue&type=style&index=0&id=37d48521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d48521",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {
  VFlex,
})
